const page = `

{settings}
document.title: Seher Yilmaz
og.title: Seher Yilmaz
og.image: http://quickshot.imgix.net/opinionsbildaren-seher-yilmaz/Seher10.png?w=1000&auto=format
og.twitterImage: http://quickshot.imgix.net/opinionsbildaren-seher-yilmaz/Seher10.png?h=120&w=120&auto=format&fit=crop
og.description: Uppvuxen i miljonprogrammet och ständigt ifrågasatt för sin bakgrund och sitt kön hade hon alla odds emot sig. I dag är Seher Yilmaz en hyllad rättvisekämpe och ansiktet utåt för Rättviseförmedlingen.
og.url: http://pejl.svt.se/opinionsbildaren-seher-yilmaz
siteCatalyst.name: opinionsbildaren-seher-yilmaz
siteCatalyst.category: lyxartikel
{}
[+page]
{.div}
  style.position:relative
  style.backgroundColor: black
  style.color:white
  style.height: 100%;
  style.marginBottom: -18px;
  [.+content]
  
  
    {.div}
      style.minHeight:70vh
      style.position:relative
      style.paddingBottom:25px
      [.+content]
        {.div}
          style.position:relative
          style.width: 300px
          style.height:45px
          style.top:20px
          style.backgroundImage: url('http://quickshot.imgix.net/annika-beijbom/ob-1-rad-vit-ht_720.png')
          style.backgroundPositionY: 50%
          style.backgroundPositionX: 0%
          style.backgroundSize: cover
          [.+content]
          []
        {}
        
        luft:-50
          rubrik3: Seher Yilmaz
          
          {.video}
            id:13525291?autostart=true
            storlek:wide
          {}
          {.citat}    
            citat: Jag hoppas på att jag bidrar till att få bort visst tunnelseende i samhället och att folk blir mer medvetna om sina fördomar och stereotypa uppfattningar.
            cstyle.color:#ddd
          {}
               
      []
    {}
    
    
   
   
 
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-seher-yilmaz/Seher3.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      style.backgroundPosition: 35% 10%
      [.+content]
      []
    {}
    
    
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: FAMILJEN
Uppvuxen i miljonprogrammet och ständigt ifrågasatt för sin bakgrund och sitt kön hade hon alla odds emot sig. I dag är Seher Yilmaz en hyllad rättvisekämpe och ansiktet utåt för Rättviseförmedlingen.

Seher är näst äldst i en syskonskara på fyra. Hon är född i Kristianstad, men flyttade som sexåring med sin familj till ett av miljonprogrammen i Lund.

Hennes pappa arbetar inom restaurangbranschen. Hennes mamma utbildade sig till undersköterska och jobbade natt medan Seher och hennes syskon var små.

Seher uppfattades tidigt som lillgammal, bestämd och nyfiken. Hon drömde om att bli jurist för att hon skulle få möjlighet att argumentera, eller journalist för att få berätta andras historier.

I dag är Seher tacksam över de val hennes föräldrar gjorde för barnens skull. Flytten till Lund ser hon själv som helt avgörande för de sammanhang hon nu befinner sig i.

– De saknade nätverk och akademisk utbildning, men kunde samtidigt titta på samhället och dra slutsatser av det. Deras drivkraft var och är att vi barn skulle få det bättre, säger hon.

            luft:
          []
        {}
      []
    {}
    
    
    
    {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:13525391
          storlek:wide

        {}
        {.citat}    
          citat: Jag är ju uppvuxen i ett jättepolitiskt hem, politik har alltid varit närvarande på ett eller annat sätt.
          cstyle.color:#ddd
        {}
      []
    {}
    

   
   {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-seher-yilmaz/Seher5.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      style.backgroundPosition: 50% 30%
      [.+content]
      []
    {}
    
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: RÄTTVISAN
            
Sehers engagemang för rättvisa startade tidigt. I mellanstadiet bråkade hon ofta med sin lärare, som ansåg att Sehers sätt att klä och sminka sig störde ordningen i klassen.

Bråket fick henne att gå med i skolans elevråd och starta en antimobbningsgrupp. Hon skrev också artiklar om lärarnas roll i Sydsvenskans ungdomstidning.
 
I högstadiet vände allt och relationen till lärarna blev en helt annan. Där blev hon uppmuntrad och hade vuxna omkring sig som tyckte att hennes ideér var värdefulla.

Hennes starka rättspatos tog henne vidare till ordförandeposten för LSU - Sveriges ungdomsorganisationer. Sedan tre år tillbaka är hon ansiktet utåt för Rättviseförmedlingen.

Via sin roll som opinionsbildare har hon i dag tillträde till de flesta rum, men blir ofta påmind om den klassresa hon gjort. Det kan handla om sådant som referenser till musik eller litteratur.

– Ibland händer det att jag på bussen på vägen hem googlar: “vad var den här grejen som alla pratade om”. Det är inte alltid så kul att berätta att man inte fattar och har helt andra referensramar. 

            luft:

          []
        {}
      []
    {}
    
    
    
    {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:13618417
          storlek:wide
        {}
        {.citat}    
          citat: När jag var liten förstod jag inte hur en sommarstuga såg ut – eller vad man gjorde på landet. Det kanske gör att man missar en del av en gemenskap.
          cstyle.color:#ddd
        {}
      []
    {}
    
    
    
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-seher-yilmaz/Seher14.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      style.backgroundPosition: 50% 20%
      [.+content]
      []
    {}
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: PÅHOPPEN
            
Hon brinner för rätten till alla människors lika värde, men har svårt att värja sig mot påhopp och blickar hon möter på tunnelbanan till följd av hennes eget ursprung.

– Det är helt sjukt att jag ska gå omkring och ta någon sorts ansvar. Om jag står i en kö eller liknande kan jag få gliringar - folk vill gärna påpeka att “i Sverige gör man si eller så”. 

Andra viktiga frågor för Seher är den stora skillnaden i lön mellan könen, rätten till likvärdig vård och minskad segregation. Men det händer att hon vacklar i sin tro på förändring.

– Allt går så sakta. Ibland går jag hem och funderar på vad jag egentligen håller på med. Då behöver jag få bekräftelse på att det vi gör faktiskt är värt att kämpa för, säger hon

Till sommaren väntar paret sitt första barn. Graviditeten får henne ofta att tänka på sin egen bakgrund och barnets framtid, som kommer skilja sig på många sätt.

            
            luft:

          []
        {}
      []
    {}
    
    
    
    
     {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:13618453
          storlek:wide
        {}
        {.citat}    
          citat: Jag funderar mycket på hur man för vidare en kultur till ett barn. Jag är ju gift med en svensk man och vi har ju två helt olika familjekulturer.
          cstyle.color:#ddd
        {}
      []
    {}
    
    
     {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-seher-yilmaz/Seher13.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb&fp-x=0.7')
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      style.backgroundPosition: 20% 40%
      [.+content]
      []
    {}
    
    
     {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: TERRORN 
            
Den 7 april 2017 utsattes Stockholm för en terrorattack. Sammanlagt fem personer avled efter att en man körde en lastbil i full fart längs Drottninggatan och in i Åhlénshuset.

Händelsen utlöste landssorg och en manifestation för kärlek samlade tiotusentals stockholmare på Sergels torg. 

SVT Opinion träffar Seher Yilmaz på Sergels torg i mars 2017 – terrorattacken på Drottninggatan har då ännu inte inträffat.

Men sex år tidigare samlades man här efter en annan terrorattack – den som utfördes av Anders Behring Breivik på norska Utöya. Seher Yilmaz var en av dem som manifesterade på Sergels torg.

Massakern i juli 2011 har påverkat henne starkt, inte minst i hennes roll som representant för olika ungdomsorganisationer genom åren. 

– Man tror att terrorism och ondska bara kan komma från ett håll. I samband med Utöya fick vi fick se prov på att så inte var fallet. Samtidigt glömde vi bort det väldigt snabbt, säger hon.

            luft:

          []
        {}
      []
    {}
    
    
    
     {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id: 13525419
          storlek:wide
        {}
        {.citat}    
          citat: Att hålla tal vid manifestationen är kanske det svåraste jag har gjort - utifrån att det kändes så oerhört mycket.
          cstyle.color:#ddd
        {}
      []
    {}
    
    
        
   
    
    
    {.div}
        style.backgroundColor: #eee
        style.color:#111
        style.maxWidth: 600px
        style.padding: 1px 12px
        style.margin: 24px auto 0
        [.+content]
           mellanrubrik: OM SEHER YILMAZ 
           
          {.bild}
            fil:opinionsbildaren-seher-yilmaz/Seher10.png
            storlek:m
            imgix.fp-y:0.2
          {}
          
          [Namn:] Seher Yilmaz.
          [Född:] Februari 1986 i Kristianstad.
          [Familj:] Maken Johan Yilmaz.
          [Bor:] I Stockholm.
          [Gör:] Ordförande för Rättviseförmedlingen, som är partipolitiskt obunden och hjälper ”projekt, organisationer, företag och medier att få fram fler än bara de givna namnen till sin urvalslista”. Hon tog över posten som ordförande i januari 2014 efter dess grundare Lina Thomsgård. Yilmaz har också varit ordförande för Sveriges Elevkårer och ledamot i Historiska museets insynsråd. Hon har examen i statsvetenskap och har varit krönikör för Nyheter24 och tidningen Chef.
Yilmaz saknar i dag politisk hemvist.
          [Oanade talanger:] Jag kan vicka på öronen. Jag tycker också att det är en oanad talang att jag numera kan åka snowboard, med tanke på att jag inte hade sett ett fjäll innan jag var 28 år.
          [Senast lästa bok:] Difficult women av Roxane Gay.
          [Förebilder:] Inte en särskild person. Jag brukar plocka bitar från olika personer, som till exempel min kompis som var med och startade Maktsalongen, som engagerar och motiverar unga kvinnor inom ideell sektor. Men också från Alexandra Pascalidous mod och framgångar i att öppna dörrar för andra - det vill jag själv bli bättre på.
          [Favoritcitat:] ”Många tror att förändring kräver tid - det är både fegt och fel”. Det kräver inte tid utan initiativ. Under 2013 fick Rättviseförmedlingen ett fint reklampris och där fanns delar av den här motiveringen med. Den formulerar oss så väl.
          [Senaste köpet:] Gravidkläder.
          [Största orättvisan:] Ojämlikhet, det är ett väldigt brett begrepp, men så känner jag.

          
          luft:
        []
      {}[
      
      
      
    
    
    luft:200
    
    rubrik5:Reporter: Magnus Nilsson
    rubrik5:Fotograf: Åke Wehrling
    rubrik5:[SVT Opinion | http://www.svt.se/opinion/om-opinionsbildaren | white | target:_self  ]
    
    {.sharebuttons}
    title: Seher Yilmaz
    url: http://pejl.svt.se/opinionsbildaren-seher-yilmaz/
    {}
       
    luft:100
   
  []
{}



[]
`;

export default page;





/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/opinionsbildaren-seher-yilmaz.js
 **/